/**
 * Parse a date string from the backend as UTC.
 * Backend sends UTC datetimes but without timezone info,
 * so we need to explicitly treat them as UTC.
 */
export const parseUTCDate = (dateString: string): Date => {
  // If already has timezone info, use as-is
  if (dateString.includes('Z') || dateString.includes('+') || dateString.includes('-', 19)) {
    return new Date(dateString);
  }
  
  // Otherwise, assume it's UTC and add 'Z' suffix
  return new Date(dateString + 'Z');
};